var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _g, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _g2, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _g3, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarBayrun3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1195,
    height: 496,
    viewBox: "0 0 1195 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.427 443.61C128.987 444.64 139.217 445.22 139.217 445.22L139.317 445.12L140.727 445.22C145.067 445.6 149.767 446.11 154.107 446.33C168.467 447.28 183.087 448.06 197.477 448.34C213.087 448.83 228.957 449.04 244.567 449.04C251.187 449.08 258.277 448.75 264.897 448.54C267.507 448.31 271.907 446.86 274.277 446.09L274.757 451.25H274.767C274.047 451.34 273.327 451.5 272.647 451.75C272.187 451.9 271.357 452.18 270.927 452.66C270.577 453.07 270.627 453.37 270.627 453.37C270.937 457.88 272.287 463.94 273.347 468.36C273.727 469.93 274.117 471.5 274.537 473.06C274.917 474.45 275.307 475.83 275.747 477.2C276.117 478.33 276.477 479.51 277.067 480.54C279.247 484.36 282.377 490.36 285.217 493.52C285.217 493.52 285.797 494.32 286.927 494.42L288.837 494.52C289.447 494.52 293.497 490.75 293.857 490.11C294.067 489.72 294.137 489.31 293.877 488.88H293.977L294.687 489.28H294.787L298.257 487.69C298.257 487.69 298.297 487.71 298.307 487.72C299.067 487.42 298.747 486.49 298.807 485.85C297.127 477.79 293.477 464.59 291.487 456.47C291.467 456.4 291.447 456.34 291.427 456.27L290.487 453.45C290.397 453.19 290.237 452.96 290.017 452.8L287.917 451.24C287.737 451.1 287.527 450.99 287.317 450.92L285.937 450.41C285.467 448.76 285.317 447.24 285.567 445.9H286.677L369.957 445.72C414.007 446.58 504.967 447.46 504.967 447.46C582.117 448.05 670.277 448.42 760.157 448.35L796.787 448.48C796.787 448.48 1033.41 447.04 1132.18 444.77C1134.3 444.72 1137.85 444.71 1137.85 444.71C1138.17 444.85 1138.4 445.11 1138.75 445.11C1147.05 444.34 1159.01 443.29 1166.93 440.98H1168.04C1168.04 440.98 1168.54 441.06 1168.85 440.28C1168.85 440.28 1171.78 439.34 1171.96 439.27C1171.96 439.27 1174.2 438.67 1174.78 437.96L1175.31 437.44L1175.57 437.16L1176.44 435.36C1176.44 435.36 1179.49 429.05 1181.06 420.73C1185.44 411.01 1187.79 399.25 1189.18 388.48C1189.32 387.42 1189.4 386.45 1189.47 385.58C1192.18 350.26 1194.39 284.93 1194.12 250.48C1194.12 249.9 1194.12 244.87 1194.12 243.9C1194.34 209.17 1192.14 144.88 1189.47 109.94C1189.4 109.07 1189.32 108.1 1189.18 107.04C1187.79 96.27 1185.44 84.51 1181.06 74.79C1179.49 66.47 1176.44 60.16 1176.44 60.16L1175.57 58.36L1175.31 58.08L1174.78 57.56C1174.2 56.85 1171.96 56.25 1171.96 56.25C1171.77 56.18 1168.85 55.25 1168.85 55.24C1168.54 54.46 1168.04 54.53 1168.04 54.53H1166.93C1159.01 52.23 1147.05 51.18 1138.75 50.41C1138.4 50.41 1138.16 50.67 1137.85 50.81C1137.85 50.81 1134.3 50.79 1132.18 50.75C1033.41 48.48 796.787 47.04 796.787 47.04L760.157 47.17C670.277 47.11 582.117 47.47 504.967 48.06C504.967 48.06 413.997 48.93 369.957 49.8L286.677 49.62H285.567C285.317 48.29 285.467 46.77 285.937 45.12L287.317 44.6C287.527 44.52 287.737 44.41 287.917 44.28L290.017 42.72C290.237 42.56 290.407 42.33 290.487 42.07L291.427 39.25C291.447 39.18 291.467 39.12 291.487 39.05C293.477 30.93 297.117 17.72 298.807 9.67C298.747 9.03 299.067 8.11 298.307 7.8C298.287 7.8 298.267 7.82 298.257 7.83L294.787 6.24H294.687L293.977 6.64H293.877C294.137 6.21 294.067 5.8 293.857 5.41C293.497 4.77 289.447 1 288.837 1L286.927 1.1C285.797 1.2 285.217 2 285.217 2C282.377 5.17 279.247 11.17 277.067 14.98C276.477 16.01 276.117 17.19 275.747 18.32C275.307 19.69 274.907 21.07 274.537 22.46C274.117 24.02 273.727 25.58 273.347 27.16C272.287 31.58 270.947 37.64 270.627 42.15C270.627 42.15 270.577 42.45 270.927 42.86C271.347 43.33 272.187 43.62 272.647 43.77C273.327 44.02 274.047 44.18 274.767 44.26H274.757L274.307 49.46C271.937 48.7 267.507 47.22 264.897 46.99C258.277 46.78 251.187 46.45 244.567 46.49C228.957 46.49 213.077 46.71 197.477 47.19C183.077 47.47 168.467 48.25 154.107 49.2C149.767 49.41 145.067 49.93 140.727 50.31L139.317 50.41L139.217 50.31C139.217 50.31 128.987 50.89 125.427 51.92M125.727 51.82C121.977 52.14 118.107 52.96 114.457 53.93C110.447 55.58 103.717 58.23 99.7666 60.07L99.1567 60.17L84.3667 62.39C68.9367 64.26 52.8367 68.3 41.1967 79.19C34.2867 85.82 28.9366 94.33 24.7966 102.94C18.5366 115.29 13.0266 128.84 9.79665 142.29C9.79665 142.29 9.28665 142.66 8.59665 145.01C6.68665 150.85 6.29665 162.73 5.67665 168.76C4.92665 179.16 3.89665 190.35 3.06665 200.76C1.37665 215.59 0.84665 231.5 1.03665 247.76C0.84665 264.02 1.37665 279.92 3.06665 294.76C3.89665 305.17 4.92665 316.36 5.67665 326.76C6.29665 332.79 6.68665 344.67 8.59665 350.51C9.29665 352.86 9.79665 353.23 9.79665 353.23C13.0266 366.68 18.5366 380.23 24.7966 392.58C28.9366 401.19 34.2867 409.7 41.1967 416.33C52.8367 427.23 68.9367 431.26 84.3667 433.13L99.1567 435.35L99.7666 435.45C103.717 437.29 110.447 439.94 114.457 441.59C118.107 442.57 121.977 443.39 125.727 443.7",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1156.69 99.1801V99.5801V99.98L1157.39 100.79L1158.81 108.23L1166.44 176.85L1168.98 245.84V245.9L1166.44 314.84L1158.81 383.46L1157.39 391",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.97 82.13C1158.97 82.13 1156.33 85.76 1157.72 91.76L1159.63 99.61V100.56C1159.63 100.56 1163.08 118.23 1165.16 134.97C1165.16 134.97 1171.77 182.94 1171.29 244.48V245.89L1171.28 251.83L1171.18 260.88L1170.78 278.9L1170.27 292.89L1169.67 306.07L1168.86 318.85L1167.95 331.12L1166.85 342.49L1165.84 352.05L1164.63 361.11L1163.42 369.77L1162.32 376.91L1161.11 383.75L1160.71 385.46L1160.41 387.28L1159.7 391",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.25 102.59L1142.42 174.94L1145.15 247.7L1142.42 320.46L1134.25 392.81",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1127.01 102.69L1135.16 174.96L1137.88 247.65V247.7L1135.16 320.33L1127.01 392.6",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1121.69 395.32L1130.25 322.41L1134.09 247.55L1130.25 172.69L1121.69 99.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.186 423.88C184.396 410.48 175.136 392.45 169.406 374.27C158.756 335.12 154.496 287.65 156.326 247.17C154.986 204.17 158.526 153.99 172.326 113.03C176.316 102.15 181.776 91.53 188.726 82.23C191.176 78.77 194.746 75.0801 197.686 71.9601L198.596 71.16C198.596 71.16 201.006 68.9401 201.006 68.9501C201.086 68.8101 201.116 68.73 201.106 68.55H201.006",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.137 386.85C147.737 343.19 147.107 289.8 147.107 247.78C147.107 205.76 147.737 152.37 165.137 108.71C166.447 105.98 169.697 98.94 171.287 96.43C172.617 93.53 170.527 91.23 167.427 92.44C161.967 94.28 151.847 96.38 145.607 98.67C141.777 100.08 140.647 101.27 138.437 103.97C131.257 115.76 124.987 140.4 123.767 147.74C118.167 177.11 117.957 210.61 118.247 247.78C117.957 284.95 118.167 318.45 123.767 347.82C124.987 355.16 131.257 379.8 138.437 391.59C140.637 394.29 141.777 395.48 145.607 396.89C151.847 399.19 161.967 401.29 167.427 403.12C170.527 404.33 172.627 402.04 171.287 399.13C169.687 396.62 166.447 389.58 165.137 386.85Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.496 247.78C149.456 205.66 149.356 132.71 177.446 88.08L147.756 96.13C144.026 97.16 140.876 98.57 138.206 101C137.176 101.94 136.356 103.08 135.736 104.33C115.386 145.51 115.576 197.16 115.576 247.77C115.576 298.39 115.386 350.05 135.736 391.22C136.356 392.47 137.176 393.62 138.206 394.55C140.876 396.98 144.026 398.39 147.756 399.42L177.446 407.47C149.356 362.84 149.456 289.89 149.496 247.77V247.78Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23707 249.12C6.37707 263.68 9.39707 314.25 10.7571 323.73C13.2871 336.11 18.6171 349.04 27.6171 358.13V358.03L27.7171 357.93H27.8171C27.9171 358.03 28.1171 358.23 28.2171 358.33L28.5171 358.23C28.5671 358.15 28.7371 357.89 28.8171 357.83C29.0971 356.77 29.0371 355.27 28.9171 354.21C28.2071 347.61 26.2271 336.64 25.4971 330.06C22.7771 310.4 21.1071 289.7 20.3671 269.88C20.0971 264.72 19.3571 247.76 19.3571 247.76C19.3571 247.76 20.0971 230.8 20.3671 225.64C21.1071 205.82 22.7871 185.12 25.4971 165.46C26.2271 158.88 28.2071 147.91 28.9171 141.31C29.0371 140.24 29.0871 138.75 28.8171 137.69C28.7371 137.64 28.5671 137.37 28.5171 137.29L28.2171 137.19C28.1171 137.29 27.9171 137.49 27.8171 137.59H27.7171L27.6171 137.49V137.39C18.6271 146.47 13.2871 159.4 10.7571 171.79C9.38707 181.27 6.36707 231.84 5.23707 246.4C5.16707 247.32 5.16707 248.21 5.23707 249.13V249.12Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M501.476 91.95H477.906V99.85H501.476V91.95Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M501.487 395.71H477.937V403.66H501.487V395.71Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.737 65.4399C206.707 65.5799 206.517 65.7099 206.537 65.8399C246.957 68.3899 288.777 73.2399 328.807 79.3299C328.737 80.0099 329.627 81.5499 329.817 82.7499C330.097 84.3099 328.607 86.5599 328.307 88.0799",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M215.397 199.38V199.68C215.217 200.03 214.807 200.37 214.487 200.59C213.557 200.74 208.667 201.58 207.747 201.7C207.067 201.95 206.277 201.64 205.937 201C205.847 200.47 205.817 199.73 205.837 199.18L207.427 171.7L211.397 144.46L217.707 117.67C217.797 117.31 218.067 116.68 218.417 116.46C219.407 116.13 222.567 115.84 223.647 115.65C223.957 115.6 224.367 115.73 224.647 115.85C224.717 115.96 224.817 116.22 224.847 116.35C219.387 143.45 216.907 171.79 215.387 199.37L215.397 199.38Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M108.116 59.1C113.486 56.41 119.816 54.05 125.426 51.96C128.986 50.93 139.216 50.35 139.216 50.35L139.316 50.45V50.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7666 60.11C103.717 58.27 110.447 55.62 114.457 53.97C118.107 52.99 121.977 52.17 125.727 51.86",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M338.237 73.69C329.217 72.59 271.817 65.86 263.487 64.03C261.487 63.55 259.277 62.65 257.447 61.72L255.737 60.71C255.497 60.63 255.187 60.53 254.917 60.47",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M251.217 60.21C229.857 58.47 220.197 57.09 200.997 68.56",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M476.517 73.69L487.297 73.66V73.69L487.597 73.8L487.797 73.99L487.897 74.19V78.83V74.19V89.09L487.797 89.39L487.597 89.69H487.297L482.567 89.7L476.627 89.59",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M796.806 47.0699L796.636 47.2499L796.536 47.5499L796.426 76.6299L795.926 78.1399L487.896 78.6499L487.996 48.6599L487.696 48.1499",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M338.967 73.6899C370.587 74.1999 444.177 73.7499 476.527 73.6899L476.627 89.5899C447.987 89.3799 418.987 88.6499 390.387 86.9699C380.147 86.2299 369.607 85.4399 359.397 84.4599C350.327 83.4699 339.237 81.8399 330.217 80.2299C330.217 80.0799 330.217 79.7799 330.217 79.6299C332.397 77.2499 335.327 75.0299 338.267 73.6899H338.967Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4863 82.4501C87.0963 82.5901 168.096 75.13 186.216 74.3",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2471 109.01C60.4871 102.67 73.8871 99.2101 86.2771 96.0301C113.947 89.2401 153.507 82.4601 181.477 76.8101C184.257 75.9101 186.637 73.79 189.217 72.48C192.797 70.51 196.967 69.21 200.997 68.55",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6162 137.39V136.89L28.3162 132.16C28.3162 132.16 28.5062 131.46 28.8162 130.6",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3162 81.54C55.1462 84.44 51.2362 88.18 47.7162 92.11C47.3962 92.49 47.0562 92.89 46.7062 93.31C44.3162 96.19 42.4062 99.06 40.9062 102.07C36.6062 111.05 32.2762 121.31 28.8262 130.65C30.8362 127.77 33.4162 125.05 35.7662 122.5C40.3562 117.39 46.9262 112.05 51.1662 106.7C60.9862 95.01 69.2862 81.12 81.9362 72.22C74.1362 74.54 66.2562 77.26 59.3162 81.54Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9268 72.22C81.9268 72.22 82.0068 72.19 82.0568 72.18L82.2568 71.98C82.1468 72.06 82.0368 72.14 81.9268 72.22Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2568 71.98C87.3268 68.79 93.1768 66.93 98.9568 65.54C131.237 61.17 222.167 56.32 253.627 56.28",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M120.507 57.8199C126.917 55.0899 134.057 52.3399 140.727 50.3499C145.067 49.9699 149.767 49.4599 154.107 49.2399C168.467 48.2899 183.087 47.5099 197.477 47.2299C213.087 46.7399 228.957 46.5299 244.567 46.5299C251.187 46.4899 258.277 46.8199 264.897 47.0299C267.887 47.2999 271.317 48.5699 274.307 49.4999",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M253.936 52.16L200.306 53.47L198.296 53.57L117.486 58L99.1664 60.21L84.3764 62.43C68.9464 64.3 52.8464 68.34 41.2064 79.23C34.2964 85.86 28.9464 94.37 24.8064 102.98C18.5464 115.33 13.0364 128.88 9.80642 142.33C9.80642 142.33 9.29642 142.7 8.60642 145.05C6.69642 150.89 6.30642 162.77 5.68642 168.8C4.93642 179.2 3.90642 190.39 3.07642 200.8C1.38642 215.63 0.856416 231.54 1.04642 247.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M287.157 442.98C339.837 442.64 435.957 442.55 453.417 442.25C454.927 442.22 456.417 441.99 457.837 441.48C461.537 440.17 465.057 438.03 467.027 434.56C468.057 432.73 468.917 430.54 468.877 428.41C468.547 426.9 466.707 426.34 465.357 426.1C462.597 425.35 459.437 425.32 456.597 425.09C432.547 424.85 391.617 425.21 367.637 425.09C353.487 424.85 338.407 426.23 324.367 428.21C300.467 430.96 275.187 433.67 251.207 435.35C251.507 436.16 251.637 437.89 252.917 437.26C254.207 438.95 253.017 441.49 253.727 443.3L253.927 443.4C256.487 443.28 263.127 443.18 272.037 443.1",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 53.77C270.187 54.86 270.727 55.78 271.937 55.99L291.917 57.19L289.847 54.07",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 53.7701C270.897 53.3801 272.697 52.2301 273.757 50.9501L274.167 50.2501C274.737 48.3801 274.807 46.2801 274.767 44.3101",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M293.887 6.67002H293.987L294.687 6.27002H294.787L298.307 7.88002",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M291.437 39.2699C291.457 39.1999 291.477 39.1399 291.497 39.0699C293.487 30.9499 297.127 17.7399 298.817 9.68995C298.757 9.04995 299.077 8.12995 298.317 7.81995C293.007 10.5099 292.117 17.8699 290.467 23.2699C289.217 28.2199 286.477 39.1599 285.437 43.8999C285.447 44.3499 285.027 45.2699 285.737 45.2099L287.327 44.6299C287.537 44.5499 287.747 44.4399 287.927 44.3099L290.027 42.7499C290.247 42.5899 290.417 42.3599 290.497 42.0999L291.437 39.2799V39.2699Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M269.126 53.77L266.616 54.07L268.596 59.92C268.736 60.34 269.106 60.64 269.546 60.67C279.476 61.48 291.306 62.64 301.206 63.57C301.416 63.59 301.526 63.33 301.376 63.18L292.476 54.57L289.856 54.07C285.456 52.63 284.776 49.25 285.936 45.15",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M285.537 45.21C282.227 46 278.377 45.05 275.137 44.33",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M293.886 6.67003C294.146 6.24003 294.076 5.83003 293.866 5.44003C293.506 4.80003 289.456 1.03003 288.846 1.03003L286.936 1.13003C285.806 1.23003 285.226 2.03003 285.226 2.03003C282.386 5.20003 279.256 11.2 277.076 15.01C276.486 16.04 276.126 17.22 275.756 18.35C275.316 19.72 274.916 21.1 274.546 22.49C274.126 24.05 273.736 25.61 273.356 27.19C272.296 31.61 270.956 37.67 270.636 42.18C270.636 42.18 270.586 42.48 270.936 42.89C271.356 43.36 272.196 43.65 272.656 43.8C275.086 44.68 277.936 44.59 279.896 42.89C281.206 42.15 281.656 38.25 282.106 36.95C284.316 29.28 286.536 17.89 289.656 10.99C289.656 10.99 290.196 10.03 290.476 9.62003C291.246 8.49003 293.246 6.16003 293.886 6.67003Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 441.8C270.187 440.71 270.727 439.79 271.937 439.58L291.917 438.38L289.847 441.5",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M269.127 441.8C270.897 442.19 272.697 443.34 273.757 444.62L274.167 445.32C274.737 447.19 274.807 449.29 274.767 451.26",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M293.887 488.89H293.987L294.687 489.3H294.787L298.307 487.69",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M291.437 456.29C291.457 456.36 291.477 456.42 291.497 456.49C293.487 464.61 297.127 477.82 298.817 485.87C298.757 486.51 299.077 487.43 298.317 487.74C293.007 485.05 292.117 477.69 290.467 472.29C289.217 467.34 286.477 456.4 285.437 451.66C285.447 451.21 285.027 450.29 285.737 450.35L287.327 450.93C287.537 451.01 287.747 451.12 287.927 451.25L290.027 452.81C290.247 452.97 290.417 453.2 290.497 453.46L291.437 456.28V456.29Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M269.126 441.8L266.616 441.5L268.596 435.65C268.736 435.23 269.106 434.93 269.546 434.9C279.476 434.09 291.306 432.93 301.206 432C301.416 431.98 301.526 432.24 301.376 432.39L292.476 441L289.856 441.5C285.456 442.94 284.776 446.32 285.936 450.42",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M285.537 450.35C282.227 449.56 278.377 450.51 275.137 451.23",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M293.886 488.89C294.146 489.32 294.076 489.73 293.866 490.12C293.506 490.76 289.456 494.53 288.846 494.53L286.936 494.43C285.806 494.33 285.226 493.53 285.226 493.53C282.386 490.36 279.256 484.36 277.076 480.55C276.486 479.52 276.126 478.34 275.756 477.21C275.316 475.84 274.916 474.46 274.546 473.07C274.126 471.51 273.736 469.95 273.356 468.37C272.296 463.95 270.956 457.89 270.636 453.38C270.636 453.38 270.586 453.08 270.936 452.67C271.356 452.2 272.196 451.91 272.656 451.76C275.086 450.88 277.936 450.97 279.896 452.67C281.206 453.41 281.656 457.31 282.106 458.61C284.316 466.28 286.536 477.67 289.656 484.57C289.656 484.57 290.196 485.53 290.476 485.94C291.246 487.07 293.246 489.4 293.886 488.89Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M275.856 80.96C275.856 80.96 277.696 87.81 267.726 87.19C267.726 87.19 255.366 86.86 242.566 84.3C242.566 84.3 226.756 81.18 209.386 76.62C209.386 76.62 201.476 91.32 196.916 105.46C196.916 105.46 196.726 105.84 197.126 106.02L197.886 106.2C197.886 106.2 189.746 129.08 185.606 169.07C185.606 169.07 181.246 205.86 181.586 247.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M207.627 79.88H203.507C203.507 79.88 196.757 94.59 194.007 103.75C194.007 103.75 187.277 113.14 186.087 118.2C186.027 118.47 185.997 118.74 185.997 119.02L185.937 130.71L180.847 159.78L181.937 160.58L180.217 172.83C180.217 172.83 179.247 173.46 179.127 174.32C179.127 174.32 176.267 207.92 175.947 218.01L175.497 230.5C175.497 230.5 175.847 231.52 176.447 231.9L176.407 240.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M169.906 247.78C170.176 118.37 199.576 74.91 199.576 74.91L200.986 74.64H201.606C251.526 76.88 329.706 88.17 329.706 88.17",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M175.347 247.78V242.01L176.117 241.44L176.667 241.31V247.78H175.347Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M175.347 242.01L175.777 241.11L176.467 240.4L176.817 240.93L176.197 241.27L175.347 242.01Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M252.116 201.9C256.136 201.5 271.166 200.87 273.346 201.39C275.016 202.29 278.266 209.82 279.026 211.35C279.046 211.39 279.086 211.53 279.086 211.57C279.106 211.95 279.006 212.33 278.676 212.56C278.106 212.98 260.306 213.2 256.936 212.66C256.286 212.66 252.466 204.63 251.806 203.6C251.666 203.34 251.466 202.9 251.506 202.6C251.506 202.6 251.446 202 252.106 201.9H252.116Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M218.416 201.98C218.416 201.98 256.346 198.26 272.056 198.16C280.266 198.05 288.666 197.92 296.806 199.17C299.956 203.29 303.006 208.26 304.756 213.16C304.756 213.16 305.766 216.12 305.856 216.49V216.47C306.016 217.03 305.116 216.73 305.116 216.73C300.726 214.99 238.466 216.58 217.606 216.07C217.606 216.07 217.846 206.51 218.416 201.98ZM218.416 201.98C218.306 202.8 218.316 201.98 218.316 201.98H218.416Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M283.316 200.59C286.416 200.65 289.906 200.7 292.976 201.1C292.976 201.1 293.526 201.15 294.186 202.11C295.086 203.42 296.396 205.32 297.106 206.74C298.196 208.63 299.366 210.98 299.926 213.08C299.976 213.31 299.826 213.28 299.826 213.28C296.816 213.11 293.476 213.11 290.436 212.99C290.136 212.98 289.846 212.86 289.646 212.63C288.956 211.83 288.446 210.15 288.046 209.46C286.746 206.67 284.316 203.6 282.716 201.01C282.716 201.01 282.366 200.51 283.316 200.61V200.59Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M296.696 198.57C295.556 169.54 292.316 111.98 290.356 82.84",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M248.196 85.36C247.926 95.36 239.886 172.72 242.156 180.66C243.106 187.41 246.756 193.83 251.916 198.27C253.136 198.2 254.826 198.04 256.046 197.87C250.876 193.49 246.976 187.41 245.886 180.66C243.616 172.96 250.846 95.48 251.016 85.87L248.196 85.37V85.36Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M213.477 216.89L267.807 216.82L283.917 216.79H288.347C288.347 216.79 291.817 230.13 291.817 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M296.846 199.2L297.836 199.37C297.836 199.37 304.796 207.46 307.306 217.22L306.096 217.91L305.926 217.43C305.926 217.43 294.686 215.96 290.276 216.7C290.276 216.7 293.646 232.82 293.646 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M291.387 223.04L291.877 221.82C291.877 221.82 299.857 221.97 301.457 222.26L301.987 223.28V223.96C301.987 223.96 303.977 233.34 303.977 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M294.637 247.78L293.767 229.45C293.767 229.45 293.767 228.87 294.397 228.87H300.867C300.867 228.87 301.697 228.58 301.787 230.47C301.787 230.47 302.807 237.17 302.807 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M308.477 247.78C308.477 134.94 330.967 92.91 330.967 92.91C329.927 92.06 330.887 90.9 330.887 90.9C331.587 89.08 330.267 88.46 330.267 88.46C329.607 88.5 329.647 87.76 329.647 87.76L330.997 83.85L334.857 84.44C334.857 84.44 338.387 85.17 335.957 89.16L334.947 91.96C334.947 91.96 311.987 129.28 311.987 247.77",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M330.606 88.74L335.966 89.17",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M331.017 89.64L335.627 90.03",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M335.587 89.96C335.587 89.96 337.867 90.1 338.517 84.01C338.517 84.01 338.567 83.08 340.327 83.45C340.327 83.45 360.827 88.35 403.037 89.2L477.907 91.95",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M334.826 92.01L359.726 95.32L477.906 99.86",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M206.737 430.13C206.707 429.99 206.517 429.86 206.537 429.73C246.957 427.18 288.777 422.33 328.807 416.24C328.737 415.56 329.627 414.02 329.817 412.82C330.097 411.26 328.607 409.01 328.307 407.49",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M215.397 296.19V295.89C215.217 295.54 214.807 295.2 214.487 294.98C213.557 294.83 208.667 293.99 207.747 293.87C207.067 293.62 206.277 293.93 205.937 294.57C205.847 295.1 205.817 295.84 205.837 296.39L207.427 323.87L211.397 351.11L217.707 377.9C217.797 378.26 218.067 378.89 218.417 379.11C219.407 379.44 222.567 379.73 223.647 379.92C223.957 379.97 224.367 379.84 224.647 379.72C224.717 379.61 224.817 379.35 224.847 379.22C219.387 352.12 216.907 323.78 215.387 296.2L215.397 296.19Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M108.116 436.47C113.486 439.16 119.816 441.52 125.426 443.61C128.986 444.64 139.216 445.22 139.216 445.22L139.316 445.12V444.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7666 435.46C103.717 437.3 110.447 439.95 114.457 441.6C118.107 442.58 121.977 443.4 125.727 443.71",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M338.237 421.88C329.217 422.98 271.817 429.71 263.487 431.54C261.487 432.02 259.277 432.92 257.447 433.85L255.737 434.86C255.497 434.94 255.187 435.04 254.917 435.1",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M251.217 435.36C229.857 437.1 220.197 438.48 200.997 427.01",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M476.517 421.88L487.297 421.91V421.88L487.597 421.77L487.797 421.58L487.897 421.38V416.75V421.38V406.48L487.797 406.18L487.597 405.88H487.297L482.567 405.87L476.627 405.98",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M796.806 448.5L796.636 448.32L796.536 448.02L796.426 418.94L795.926 417.43L487.896 416.92L487.996 446.91L487.696 447.42",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M338.967 421.88C370.587 421.37 444.177 421.82 476.527 421.88L476.627 405.98C447.987 406.19 418.987 406.92 390.387 408.6C380.147 409.34 369.607 410.13 359.397 411.11C350.327 412.1 339.237 413.73 330.217 415.34C330.217 415.49 330.217 415.79 330.217 415.94C332.397 418.32 335.327 420.54 338.267 421.88H338.967Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4863 413.12C87.0963 412.98 168.096 420.44 186.216 421.27",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2471 386.56C60.4871 392.9 73.8871 396.36 86.2771 399.54C113.947 406.33 153.507 413.11 181.477 418.76C184.257 419.66 186.637 421.78 189.217 423.09C192.797 425.06 196.967 426.36 200.997 427.02",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6162 358.18V358.68L28.3162 363.41C28.3162 363.41 28.5062 364.11 28.8162 364.97",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3162 414.03C55.1462 411.13 51.2362 407.39 47.7162 403.46C47.3962 403.08 47.0562 402.68 46.7062 402.26C44.3162 399.38 42.4062 396.51 40.9062 393.5C36.6062 384.52 32.2762 374.26 28.8262 364.92C30.8362 367.8 33.4162 370.52 35.7662 373.07C40.3562 378.18 46.9262 383.52 51.1662 388.87C60.9862 400.56 69.2862 414.45 81.9362 423.35C74.1362 421.03 66.2562 418.31 59.3162 414.03Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9268 423.35C81.9268 423.35 82.0068 423.38 82.0568 423.39L82.2568 423.59C82.1468 423.51 82.0368 423.43 81.9268 423.35Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2568 423.59C87.3268 426.78 93.1768 428.64 98.9568 430.03C131.237 434.4 222.167 439.25 253.627 439.29",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M120.507 437.75C126.917 440.48 134.057 443.23 140.727 445.22C145.067 445.6 149.767 446.11 154.107 446.33C168.467 447.28 183.087 448.06 197.477 448.34C213.087 448.83 228.957 449.04 244.567 449.04C251.187 449.08 258.277 448.75 264.897 448.54C268.287 448.24 271.007 447.01 274.277 446.09",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M253.936 443.41L200.306 442.1L198.296 442L117.486 437.57L99.1664 435.36L84.3764 433.14C68.9464 431.27 52.8464 427.23 41.2064 416.34C34.2964 409.71 28.9464 401.2 24.8064 392.59C18.5464 380.24 13.0364 366.69 9.80642 353.24C9.80642 353.24 9.29642 352.87 8.60642 350.52C6.69642 344.68 6.30642 332.8 5.68642 326.77C4.93642 316.37 3.90642 305.18 3.07642 294.77C1.38642 279.94 0.856416 264.03 1.04642 247.77",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M275.856 414.61C275.856 414.61 277.696 407.76 267.726 408.38C267.726 408.38 255.366 408.71 242.566 411.27C242.566 411.27 226.756 414.39 209.386 418.95C209.386 418.95 201.476 404.25 196.916 390.11C196.916 390.11 196.726 389.73 197.126 389.55L197.886 389.37C197.886 389.37 189.746 366.49 185.606 326.5C185.606 326.5 181.246 289.71 181.586 247.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M207.627 415.69H203.507C203.507 415.69 196.757 400.98 194.007 391.82C194.007 391.82 187.277 382.43 186.087 377.37C186.027 377.1 185.997 376.83 185.997 376.55L185.937 364.86L180.847 335.79L181.937 334.99L180.217 322.74C180.217 322.74 179.247 322.11 179.127 321.25C179.127 321.25 176.267 287.65 175.947 277.56L175.497 265.07C175.497 265.07 175.847 264.05 176.447 263.67L176.407 255.17",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M169.906 247.79C170.176 377.2 199.576 420.66 199.576 420.66L200.986 420.93H201.606C251.526 418.69 329.706 407.4 329.706 407.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M175.347 247.79V253.56L176.117 254.13L176.667 254.26V247.79H175.347Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M175.347 253.56L175.777 254.46L176.467 255.17L176.817 254.64L176.197 254.3L175.347 253.56Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M252.116 293.67C256.136 294.07 271.166 294.7 273.346 294.18C275.016 293.28 278.266 285.75 279.026 284.22C279.046 284.18 279.086 284.04 279.086 284C279.106 283.62 279.006 283.24 278.676 283.01C278.106 282.59 260.306 282.37 256.936 282.91C256.286 282.91 252.466 290.94 251.806 291.97C251.666 292.23 251.466 292.67 251.506 292.97C251.506 292.97 251.446 293.57 252.106 293.67H252.116Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M218.416 293.59C218.416 293.59 256.346 297.31 272.056 297.41C280.266 297.52 288.666 297.65 296.806 296.4C299.956 292.28 303.006 287.31 304.756 282.41C304.756 282.41 305.766 279.45 305.856 279.08V279.1C306.016 278.54 305.116 278.84 305.116 278.84C300.726 280.58 238.466 278.99 217.606 279.5C217.606 279.5 217.846 289.06 218.416 293.59ZM218.416 293.59C218.306 292.77 218.316 293.59 218.316 293.59H218.416Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M283.316 294.98C286.416 294.92 289.906 294.87 292.976 294.47C292.976 294.47 293.526 294.42 294.186 293.46C295.086 292.15 296.396 290.25 297.106 288.83C298.196 286.94 299.366 284.59 299.926 282.49C299.976 282.26 299.826 282.29 299.826 282.29C296.816 282.46 293.476 282.46 290.436 282.58C290.136 282.59 289.846 282.71 289.646 282.94C288.956 283.74 288.446 285.42 288.046 286.11C286.746 288.9 284.316 291.97 282.716 294.56C282.716 294.56 282.366 295.06 283.316 294.96V294.98Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M296.696 297C295.556 326.03 292.316 383.59 290.356 412.73",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M248.196 410.21C247.926 400.21 239.886 322.85 242.156 314.91C243.106 308.16 246.756 301.74 251.916 297.3C253.136 297.37 254.826 297.53 256.046 297.7C250.876 302.08 246.976 308.16 245.886 314.91C243.616 322.61 250.846 400.09 251.016 409.7L248.196 410.2V410.21Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M213.477 278.68L267.807 278.75L283.917 278.78H288.347C288.347 278.78 291.817 265.44 291.817 247.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M296.846 296.37L297.836 296.2C297.836 296.2 304.796 288.11 307.306 278.35L306.096 277.66L305.926 278.14C305.926 278.14 294.686 279.61 290.276 278.87C290.276 278.87 293.646 262.75 293.646 247.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M291.387 272.54L291.877 273.76C291.877 273.76 299.857 273.61 301.457 273.32L301.987 272.3V271.62C301.987 271.62 303.977 262.24 303.977 247.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M294.637 247.79L293.767 266.12C293.767 266.12 293.767 266.7 294.397 266.7H300.867C300.867 266.7 301.697 266.99 301.787 265.1C301.787 265.1 302.807 258.4 302.807 247.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M308.477 247.79C308.477 360.63 330.967 402.66 330.967 402.66C329.927 403.51 330.887 404.67 330.887 404.67C331.587 406.49 330.267 407.11 330.267 407.11C329.607 407.07 329.647 407.81 329.647 407.81L330.997 411.72L334.857 411.13C334.857 411.13 338.387 410.4 335.957 406.41L334.947 403.61C334.947 403.61 311.987 366.29 311.987 247.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M330.606 406.83L335.966 406.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M331.017 405.93L335.627 405.54",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M335.587 405.61C335.587 405.61 337.867 405.47 338.517 411.56C338.517 411.56 338.567 412.49 340.327 412.12C340.327 412.12 360.827 407.22 403.037 406.37L477.907 403.62",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M334.826 403.56L359.726 400.25L477.906 395.71",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M479.347 391.42V395.83",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M367.347 296.43L367.847 296.93L367.947 297.03C374.497 304.35 379.967 308.78 388.827 312.13C389.467 312.37 390.887 312.73 390.887 312.73C393.727 313.76 397.227 314.47 400.247 314.86C413.897 315.59 441.717 316.55 455.187 317.05",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M369.356 295.52C372.356 298.74 375.536 302.4 379.236 304.86C379.396 304.97 379.526 305.08 379.526 305.08C386.736 309.88 395.336 312.77 403.996 313.11C404.226 313.11 404.516 313.14 404.626 313.15C419.566 313.69 435.816 314.22 450.766 314.85",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M372.807 299.2C373.387 298.71 376.467 297.81 377.037 297.79C378.907 297.43 383.587 297.19 383.587 297.19C393.977 296.88 404.817 298.71 414.977 300.82C419.567 301.83 424.857 303.43 429.467 304.24C432.637 304.54 435.897 305.14 439.097 305.23C439.277 305.23 439.427 305.24 439.427 305.24C440.927 305.33 442.557 305.36 444.057 305.34",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M370.866 300.15C367.416 301.96 365.646 304.86 364.926 306.09C362.876 309.24 361.236 321.99 360.396 325.72L358.986 337.69L358.376 343.73L357.976 349.67C357.666 356.41 357.556 360.4 359.446 372.84V372.8C361.126 378.29 363.226 382.58 368.606 384.82",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M443.016 302.17C440.206 302.07 437.356 301.61 434.566 301.26C423.146 298.91 409.796 295.13 398.236 293.71C390.976 293.06 381.986 292.93 374.686 293.94C374.516 293.96 372.346 294.5 371.466 294.81C369.806 295.42 367.896 296.08 366.536 296.93C364.946 297.89 362.816 299.85 362.816 299.85C358.476 303.96 357.576 311 356.576 316.65L355.166 324.3L353.956 331.95C353.656 334.5 352.886 341.06 352.656 343.52L352.256 351.27C352.206 360.86 353.436 370.97 357.186 379.85C358.636 383.12 361.046 386.07 364.226 387.8C364.226 387.8 364.936 388.21 365.726 388.64C365.936 388.75 366.146 388.85 366.366 388.93C367.856 389.48 369.426 390.12 371.016 390.54C379.286 392.56 392.026 393.01 401.866 391.92C412.306 391 424.636 388.09 435.206 387.56L437.166 387.5H440.946",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M442.306 384.63C437.066 383.93 432.096 384.16 426.856 384.47C419.866 385.13 412.276 386.95 405.146 387.56C405.146 387.56 403.666 387.71 403.086 387.77C395.976 388.45 388.516 388.65 381.476 388.1C377.876 387.65 374.116 387.44 370.816 385.89",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M472.207 304.68C472.017 305.84 471.487 310.77 471.297 312.03C471.017 313.36 470.887 313.85 470.347 314.39C469.837 314.89 469.177 315.19 468.477 315.29C463.817 315.97 458.027 316 453.387 316.16C451.587 316.07 450.317 314.42 449.257 313.34C446.267 310.03 444.047 306.38 443.017 302.17",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M469.167 387.89C468.977 386.73 468.447 381.8 468.257 380.54C467.977 379.21 467.847 378.72 467.307 378.18C466.797 377.68 466.137 377.38 465.437 377.28C460.777 376.6 454.987 376.57 450.347 376.41C448.547 376.5 447.277 378.15 446.217 379.23C443.227 382.54 441.007 386.19 439.977 390.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M470.786 316.84L470.186 346.44L468.776 375.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M468.777 375.93C468.227 375.66 454.177 374.5 453.177 374.42",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M456.306 316.15L455.196 317.06",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M453.076 376.61L454.186 346.75L455.196 317.06",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M386.666 373.61L387.666 345.64L387.766 342.82L388.876 312.13",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M431.646 372.81L432.656 344.53L433.757 316.25",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M453.196 373.61C437.716 373.29 411.066 371.55 395.476 371.83C391.886 372.3 389.756 372.7 385.966 373.71C384.426 374.32 382.756 374.75 381.236 375.42C380.256 376.07 379.136 376.65 378.116 377.23C373.646 380.39 368.806 384.15 365.336 388.4",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M367.236 389.21C376.126 381.02 377.966 377.42 390.386 374.72C393.306 374.14 396.256 373.68 399.236 373.61C415.156 374.13 432.706 374.94 448.646 375.42L450.556 375.52L453.096 375.62",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M455.196 318.32L458.176 318.16C458.176 318.16 470.656 317.23 470.776 316.85C470.776 316.85 472.796 315.31 473.156 305.31",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M494.697 316.84C494.797 307.93 493.707 307.54 493.707 307.54C486.677 301.31 461.347 297.94 461.347 297.94L451.347 297.25C441.647 297.74 442.937 302.1 442.937 302.1C442.937 302.1 444.027 297.25 460.847 301.41L470.937 304.08C470.937 304.08 481.427 307.44 480.837 316.95L480.737 347.94C480.737 347.94 480.377 381 475.987 383.75L469.157 387.91C469.157 387.91 448.477 395.73 439.967 390.68",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M455.796 297.54L468.856 300.61C468.856 300.61 477.866 302.89 481.026 307.54C481.026 307.54 483.306 309.82 483.306 317.04",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M480.546 307.04C480.546 307.04 482.926 305.95 493.706 307.53",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M439.997 390.67C439.997 390.67 439.537 394.14 445.437 394.6C445.437 394.6 454.937 396.37 472.167 389.69L476.757 386.48C476.757 386.48 479.557 384.89 480.357 380.91C480.357 380.91 481.667 375.14 481.667 372.52",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M468.616 375.94C468.616 375.94 470.006 376.24 470.006 379.21L469.986 387.39",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M477.756 385.69C477.756 385.69 485.536 386.98 491.206 385.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M447.286 394.85C447.286 394.85 460.626 396.02 475.716 392.38L485.996 389.65C485.996 389.65 492.176 387.89 492.176 382.95L492.956 373.52",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M501.017 354.17C500.477 366.99 498.617 369.65 498.617 369.65C497.087 373.42 493.527 373.4 493.527 373.4L483.597 373.35C481.947 373.31 480.697 371.81 480.787 370L482.497 345.3L482.417 342.21V319.63C482.417 317.98 483.757 316.64 485.407 316.64L495.357 316.84C495.357 316.84 498.937 316.91 500.267 320.38C500.267 320.38 502.517 323.6 501.667 340.13C501.667 340.13 501.087 352.35 501.007 354.17H501.017Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M480.807 369.71C480.807 369.71 484.157 369.49 486.087 361.04C486.087 361.04 487.287 356.9 487.717 349.19C487.777 348.09 488.197 340.18 488.157 339.27C487.957 333.56 487.227 328.29 487.227 328.29C485.797 319.5 482.417 319.9 482.417 319.9",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M830.447 71.08C829.897 70.93 827.847 70.72 827.117 70.18C826.377 69.73 826.107 68.86 825.987 67.91C825.867 66.96 825.657 64.55 825.647 64.2C825.577 62.38 825.757 60.44 826.117 58.71C826.347 57.59 827.017 56.49 827.017 56.49C827.017 56.49 827.377 55.76 827.927 55.49C830.657 54.96 833.677 54.92 836.547 54.9L1127.1 58.41C1124.82 60.99 1121.89 63.82 1119.35 66.16C1117.86 67.55 1115.93 69.65 1114.12 70.59C1110.4 72.25 1106.05 72.51 1102.04 72.9L1083.32 73.1L831.027 71.15L830.437 71.09L830.447 71.08Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.28 50.9501C951.557 46.4801 688.207 46.6301 496.497 48.1601C493.467 48.1801 483.887 48.1301 481.797 48.1001C443.907 47.5401 331.787 51.5801 285.797 50.4601",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M830.357 71.14L796.427 70.87",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.81 91.92H501.486V99.87H1126.81V91.92Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.43 77.82L1131.13 77.21L1130.83 77.11L1125.09 76.92L1115.94 76.61L1106.67 76.41L1097.42 76.21L1088.16 76.11L1069.75 75.91L1052.34 75.7L796.437 73.89",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M1175.01 246.78V247.68V247.78L1175.11 247.99L1175.41 248.08H1177.12H1178.53L1178.73 248.18L1178.93 248.29V248.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M1192.21 246.77V247.78V248.08L1192.32 248.29L1192.56 248.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.44 113.64L1165.54 120.29L1167.05 129.64L1168.26 138.6L1169.47 147.86L1170.07 153.99L1170.68 160.23L1171.79 172.71L1172.29 179.66L1172.79 186.7L1173.5 200.08L1173.9 211.25L1174.1 219.1L1174.3 227.05L1174.5 238.32V246.07V246.27L1174.6 246.57L1174.7 246.78H1174.8H1194.13",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.73 102.78L1177.82 102.98",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.99 87.8199L1177.82 102.98",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.29 246.78C1188.42 243.08 1186.95 206.08 1188.59 203.71C1188.65 199.33 1188.53 194.8 1188.39 190.43C1187.34 169.12 1185.49 147.07 1182.55 125.93C1181.79 120.54 1180.89 114.73 1179.73 109.43C1179.18 107.35 1178.93 104.84 1177.82 102.99L1177.72 102.79C1177.58 102.68 1177.29 102.52 1177.11 102.49C1175.35 104.08 1173.49 106.17 1171.78 107.82C1170.6 109.15 1168.74 110.63 1168.66 112.55",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.83 110.42L1163.23 106.9V106.6L1163.02 102.56",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.83 110.42L1164.44 113.64",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.04 74.7C1185.45 84.44 1187.81 96.26 1189.21 107.06C1189.35 108.12 1189.43 109.09 1189.5 109.96C1192.25 145.88 1194.49 212.81 1194.13 246.77",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.9 53.78L1140.29 53.87C1149.53 54.47 1159.95 56.24 1168.89 58.77L1171.01 59.27L1174.81 57.59",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.96 54.5699C1159.04 52.2699 1147.08 51.2099 1138.78 50.4399C1138.43 50.4399 1138.19 50.6999 1137.88 50.8399",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.43 55.24L1168.07 54.56C1168.07 54.56 1168.7 54.46 1168.98 55.58L1169.61 58.66L1157.52 55.5C1157.52 55.5 1157.29 55.4 1157.44 55.24H1157.43Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.87 55.28C1168.87 55.28 1171.8 56.22 1171.98 56.29C1171.98 56.29 1174.22 56.89 1174.8 57.6L1175.33 58.12L1175.28 58.28L1171.18 59.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.36 50.96L1139.57 51.31L1139.99 54.66L1137.78 61.41L1130.62 77.11",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1171 59.27L1171.18 59.92L1171.48 61.96",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.21 61.22L1156.96 82.05C1156.96 82.05 1154.39 85.7 1155.23 91.93L1157.1 101.01H1133.04L1131.4 90.9L1129.43 90.53C1130.41 79.25 1131.54 77.52 1131.54 77.52L1138.84 61.79L1140.99 54.96L1146.09 55.47L1154.33 56.64L1160.42 57.95L1168.61 60.52C1168.61 60.52 1171.47 60.85 1173.24 64.87C1173.24 64.87 1175.54 69.66 1176.54 74.44C1176.54 74.44 1176.66 74.99 1176.4 75.34L1172.3 80.19",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.43 90.53C1129.43 90.53 1129.38 91.33 1128.96 91.28V92.73",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.86 92.74H1129.22C1129.22 92.74 1129.3 101.3 1128.64 102.61",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.91 71.1801L1158.97 84.0201C1159.24 82.7201 1155.32 81.26 1152.4 80.37C1150.74 79.86 1149.05 79.4701 1147.34 79.1701L1143 78.4001L1131.67 77.3201",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.25 69.2599C1171.07 73.1499 1172.22 79.9899 1172.22 79.9899C1172.25 80.9899 1170.61 81.1199 1170.61 81.1199C1169.05 74.2899 1166.54 70.4599 1166.54 70.4599L1166.28 67.8199C1166.28 67.8199 1166.97 67.4399 1168.02 68.9499L1168.25 69.2599Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.34 63.22L1168.3 69.21",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.6 81.12L1170.74 81.64L1163.21 92.43L1162.68 95.69L1163.29 94.31L1164.22 93.09L1171.49 82.67L1176.71 76.47C1176.71 76.47 1177.13 76.13 1177.27 77.05L1177.77 79.01L1180 78.43C1180 78.43 1181.64 78.09 1181.37 76.35C1179.92 67.28 1176.48 60.19 1176.48 60.19L1175.61 58.39L1175.35 58.11",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.66 83.89C1170.66 83.89 1171.13 83.69 1171.24 84.26L1172.3 88.42C1172.3 88.42 1172.43 89.14 1172.64 89.03L1173.81 87.55C1173.81 87.55 1173.94 87.33 1173.76 86.75L1172.65 81.98C1172.65 81.98 1172.62 81.71 1172.25 81.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.58 78.11L1180.26 80.39C1180.26 80.39 1180.05 81.08 1179.2 82.14L1167.69 97.63C1167.69 97.63 1166.45 98.63 1167.35 105.63",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.7 92.4399L1168.75 112.8L1173.1 148.97L1176.87 181.21L1178.77 246.77",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.45 81.61L1162.05 84.23",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M1163 86.2L1164.33 90.6199V90.79",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.68 95.6899L1163.02 102.56",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.02 102.56L1126.99 102.64",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M830.447 424.49C829.897 424.64 827.847 424.85 827.117 425.39C826.377 425.84 826.107 426.71 825.987 427.66C825.867 428.61 825.657 431.02 825.647 431.37C825.577 433.19 825.757 435.13 826.117 436.86C826.347 437.98 827.017 439.08 827.017 439.08C827.017 439.08 827.377 439.81 827.927 440.08C830.657 440.61 833.677 440.65 836.547 440.67L1127.1 437.16C1124.82 434.58 1121.89 431.75 1119.35 429.41C1117.86 428.02 1115.93 425.92 1114.12 424.98C1110.4 423.32 1106.05 423.06 1102.04 422.67L1083.32 422.47L831.027 424.42L830.437 424.48L830.447 424.49Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.28 444.62C951.557 449.09 688.207 448.94 496.497 447.41C493.467 447.39 483.887 447.44 481.797 447.47C443.907 448.03 331.787 443.99 285.797 445.11",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M830.357 424.43L796.427 424.7",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.81 395.7H501.486V403.65H1126.81V395.7Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M1131.43 417.75L1131.13 418.36L1130.83 418.46L1125.09 418.65L1115.94 418.96L1106.67 419.16L1097.42 419.36L1088.16 419.46L1069.75 419.66L1052.34 419.87L796.437 421.68",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.44 381.93L1165.54 375.28L1167.05 365.93L1168.26 356.97L1169.47 347.71L1170.07 341.58L1170.68 335.34L1171.79 322.86L1172.29 315.91L1172.79 308.87L1173.5 295.49L1173.9 284.32L1174.1 276.47L1174.3 268.52L1174.5 257.25V249.5V249.3L1174.6 249L1174.7 248.79L1174.8 248.8H1194.13",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M1177.73 392.79L1177.82 392.59",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M1174.99 407.75L1177.82 392.59",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M1188.29 248.8C1188.42 252.5 1186.95 289.5 1188.59 291.87C1188.65 296.25 1188.53 300.78 1188.39 305.15C1187.34 326.46 1185.49 348.51 1182.55 369.65C1181.79 375.04 1180.89 380.85 1179.73 386.15C1179.18 388.23 1178.93 390.74 1177.82 392.59L1177.72 392.79C1177.58 392.9 1177.29 393.06 1177.11 393.09C1175.35 391.5 1173.49 389.41 1171.78 387.76C1170.6 386.43 1168.74 384.95 1168.66 383.03",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.83 385.15L1163.23 388.67V388.97L1163.02 393.01",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.83 385.15L1164.44 381.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M1181.04 420.87C1185.45 411.13 1187.81 399.31 1189.21 388.51C1189.35 387.45 1189.43 386.48 1189.5 385.61C1192.25 349.69 1194.49 282.76 1194.13 248.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.9 441.8L1140.29 441.71C1149.53 441.11 1159.95 439.34 1168.89 436.81L1171.01 436.31L1174.81 437.99",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.96 441C1159.04 443.3 1147.08 444.36 1138.78 445.13C1138.43 445.13 1138.19 444.87 1137.88 444.73",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.43 440.33L1168.07 441.01C1168.07 441.01 1168.7 441.11 1168.98 439.99L1169.61 436.91L1157.52 440.07C1157.52 440.07 1157.29 440.17 1157.44 440.33H1157.43Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.87 440.29C1168.87 440.29 1171.8 439.35 1171.98 439.28C1171.98 439.28 1174.22 438.68 1174.8 437.97L1175.33 437.45L1175.28 437.29L1171.18 435.64",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M1139.36 444.61L1139.57 444.26L1139.99 440.91L1137.78 434.16L1130.62 418.46",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M1171 436.3L1171.18 435.65L1171.48 433.61",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.21 434.35L1156.96 413.52C1156.96 413.52 1154.39 409.87 1155.23 403.64L1157.1 394.56H1133.04L1131.4 404.67L1129.43 405.04C1130.41 416.32 1131.54 418.05 1131.54 418.05L1138.84 433.78L1140.99 440.61L1146.09 440.1L1154.33 438.93L1160.42 437.62L1168.61 435.05C1168.61 435.05 1171.47 434.72 1173.24 430.7C1173.24 430.7 1175.54 425.91 1176.54 421.13C1176.54 421.13 1176.66 420.58 1176.4 420.23L1172.3 415.38",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.43 405.04C1129.43 405.04 1129.38 404.24 1128.96 404.29V402.84",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.86 402.83H1129.22C1129.22 402.83 1129.3 394.27 1128.64 392.96",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.91 424.39L1158.97 411.55C1159.24 412.85 1155.32 414.31 1152.4 415.2C1150.74 415.71 1149.05 416.1 1147.34 416.4L1143 417.17L1131.67 418.25",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M1168.25 426.31C1171.07 422.42 1172.22 415.58 1172.22 415.58C1172.25 414.58 1170.61 414.45 1170.61 414.45C1169.05 421.28 1166.54 425.11 1166.54 425.11L1166.28 427.75C1166.28 427.75 1166.97 428.13 1168.02 426.62L1168.25 426.31Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M1172.34 432.35L1168.3 426.36",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.6 414.45L1170.74 413.93L1163.21 403.14L1162.68 399.88L1163.29 401.26L1164.22 402.48L1171.49 412.9L1176.71 419.1C1176.71 419.1 1177.13 419.44 1177.27 418.52L1177.77 416.56L1180 417.14C1180 417.14 1181.64 417.48 1181.37 419.22C1179.92 428.29 1176.48 435.38 1176.48 435.38L1175.61 437.18L1175.35 437.46",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M1170.66 411.68C1170.66 411.68 1171.13 411.88 1171.24 411.31L1172.3 407.15C1172.3 407.15 1172.43 406.43 1172.64 406.54L1173.81 408.02C1173.81 408.02 1173.94 408.24 1173.76 408.82L1172.65 413.59C1172.65 413.59 1172.62 413.86 1172.25 413.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M1180.58 417.46L1180.26 415.18C1180.26 415.18 1180.05 414.49 1179.2 413.43L1167.69 397.94C1167.69 397.94 1166.45 396.94 1167.35 389.94",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M1164.7 403.13L1168.75 382.77L1173.1 346.6L1176.87 314.36L1178.77 248.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M1160.45 413.96L1162.05 411.34",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M1163 409.37L1164.33 404.95V404.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M1162.68 399.88L1163.02 393.01",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M1163.02 393.01L1126.99 392.93",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M125.427 443.61C128.987 444.64 139.217 445.22 139.217 445.22L139.317 445.12L140.727 445.22C145.067 445.6 149.767 446.11 154.107 446.33C168.467 447.28 183.087 448.06 197.477 448.34C213.087 448.83 228.957 449.04 244.567 449.04C251.187 449.08 258.277 448.75 264.897 448.54C267.507 448.31 271.907 446.86 274.277 446.09L274.757 451.25H274.767C274.047 451.34 273.327 451.5 272.647 451.75C272.187 451.9 271.357 452.18 270.927 452.66C270.577 453.07 270.627 453.37 270.627 453.37C270.937 457.88 272.287 463.94 273.347 468.36C273.727 469.93 274.117 471.5 274.537 473.06C274.917 474.45 275.307 475.83 275.747 477.2C276.117 478.33 276.477 479.51 277.067 480.54C279.247 484.36 282.377 490.36 285.217 493.52C285.217 493.52 285.797 494.32 286.927 494.42L288.837 494.52C289.447 494.52 293.497 490.75 293.857 490.11C294.067 489.72 294.137 489.31 293.877 488.88H293.977L294.687 489.28H294.787L298.257 487.69C298.257 487.69 298.297 487.71 298.307 487.72C299.067 487.42 298.747 486.49 298.807 485.85C297.127 477.79 293.477 464.59 291.487 456.47C291.467 456.4 291.447 456.34 291.427 456.27L290.487 453.45C290.397 453.19 290.237 452.96 290.017 452.8L287.917 451.24C287.737 451.1 287.527 450.99 287.317 450.92L285.937 450.41C285.467 448.76 285.317 447.24 285.567 445.9H286.677L369.957 445.72C414.007 446.58 504.967 447.46 504.967 447.46C582.117 448.05 670.277 448.42 760.157 448.35L796.787 448.48C796.787 448.48 1033.41 447.04 1132.18 444.77C1134.3 444.72 1137.85 444.71 1137.85 444.71C1138.17 444.85 1138.4 445.11 1138.75 445.11C1147.05 444.34 1159.01 443.29 1166.93 440.98H1168.04C1168.04 440.98 1168.54 441.06 1168.85 440.28C1168.85 440.28 1171.78 439.34 1171.96 439.27C1171.96 439.27 1174.2 438.67 1174.78 437.96L1175.31 437.44L1175.57 437.16L1176.44 435.36C1176.44 435.36 1179.49 429.05 1181.06 420.73C1185.44 411.01 1187.79 399.25 1189.18 388.48C1189.32 387.42 1189.4 386.45 1189.47 385.58C1192.18 350.26 1194.39 284.93 1194.12 250.48C1194.12 249.9 1194.12 244.87 1194.12 243.9C1194.34 209.17 1192.14 144.88 1189.47 109.94C1189.4 109.07 1189.32 108.1 1189.18 107.04C1187.79 96.27 1185.44 84.51 1181.06 74.79C1179.49 66.47 1176.44 60.16 1176.44 60.16L1175.57 58.36L1175.31 58.08L1174.78 57.56C1174.2 56.85 1171.96 56.25 1171.96 56.25C1171.77 56.18 1168.85 55.25 1168.85 55.24C1168.54 54.46 1168.04 54.53 1168.04 54.53H1166.93C1159.01 52.23 1147.05 51.18 1138.75 50.41C1138.4 50.41 1138.16 50.67 1137.85 50.81C1137.85 50.81 1134.3 50.79 1132.18 50.75C1033.41 48.48 796.787 47.04 796.787 47.04L760.157 47.17C670.277 47.11 582.117 47.47 504.967 48.06C504.967 48.06 413.997 48.93 369.957 49.8L286.677 49.62H285.567C285.317 48.29 285.467 46.77 285.937 45.12L287.317 44.6C287.527 44.52 287.737 44.41 287.917 44.28L290.017 42.72C290.237 42.56 290.407 42.33 290.487 42.07L291.427 39.25C291.447 39.18 291.467 39.12 291.487 39.05C293.477 30.93 297.117 17.72 298.807 9.67C298.747 9.03 299.067 8.11 298.307 7.8C298.287 7.8 298.267 7.82 298.257 7.83L294.787 6.24H294.687L293.977 6.64H293.877C294.137 6.21 294.067 5.8 293.857 5.41C293.497 4.77 289.447 1 288.837 1L286.927 1.1C285.797 1.2 285.217 2 285.217 2C282.377 5.17 279.247 11.17 277.067 14.98C276.477 16.01 276.117 17.19 275.747 18.32C275.307 19.69 274.907 21.07 274.537 22.46C274.117 24.02 273.727 25.58 273.347 27.16C272.287 31.58 270.947 37.64 270.627 42.15C270.627 42.15 270.577 42.45 270.927 42.86C271.347 43.33 272.187 43.62 272.647 43.77C273.327 44.02 274.047 44.18 274.767 44.26H274.757L274.307 49.46C271.937 48.7 267.507 47.22 264.897 46.99C258.277 46.78 251.187 46.45 244.567 46.49C228.957 46.49 213.077 46.71 197.477 47.19C183.077 47.47 168.467 48.25 154.107 49.2C149.767 49.41 145.067 49.93 140.727 50.31L139.317 50.41L139.217 50.31C139.217 50.31 128.987 50.89 125.427 51.92M125.727 51.82C121.977 52.14 118.107 52.96 114.457 53.93C110.447 55.58 103.717 58.23 99.7666 60.07L99.1567 60.17L84.3667 62.39C68.9367 64.26 52.8367 68.3 41.1967 79.19C34.2867 85.82 28.9366 94.33 24.7966 102.94C18.5366 115.29 13.0266 128.84 9.79665 142.29C9.79665 142.29 9.28665 142.66 8.59665 145.01C6.68665 150.85 6.29665 162.73 5.67665 168.76C4.92665 179.16 3.89665 190.35 3.06665 200.76C1.37665 215.59 0.84665 231.5 1.03665 247.76C0.84665 264.02 1.37665 279.92 3.06665 294.76C3.89665 305.17 4.92665 316.36 5.67665 326.76C6.29665 332.79 6.68665 344.67 8.59665 350.51C9.29665 352.86 9.79665 353.23 9.79665 353.23C13.0266 366.68 18.5366 380.23 24.7966 392.58C28.9366 401.19 34.2867 409.7 41.1967 416.33C52.8367 427.23 68.9367 431.26 84.3667 433.13L99.1567 435.35L99.7666 435.45C103.717 437.29 110.447 439.94 114.457 441.59C118.107 442.57 121.977 443.39 125.727 443.7",
    stroke: "#26231E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M478.887 48.73V91.95",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M330.097 79.63V50.25",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M600.356 254.02C600.356 254.02 602.336 257.05 602.336 276.75V372.28C602.336 372.28 602.356 384.13 600.546 391.41",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M515.066 396.02C515.066 396.02 516.936 393.55 529.086 393.55C541.236 393.55 588.016 393.55 588.016 393.55C588.016 393.55 595.326 393.52 599.816 395.78",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M687.036 252.44H600.396C598.839 252.44 597.576 253.703 597.576 255.26V388.54C597.576 390.097 598.839 391.36 600.396 391.36H687.036C688.594 391.36 689.856 390.097 689.856 388.54V255.26C689.856 253.703 688.594 252.44 687.036 252.44Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M687.206 390C687.206 390 684.116 386.97 684.116 367.27V271.74C684.116 271.74 684.076 259.89 686.916 252.61",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M686.656 253.35C686.656 253.35 684.726 256.62 672.226 256.62C659.726 256.62 611.596 256.62 611.596 256.62C611.596 256.62 604.076 256.66 599.456 253.66",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M600.456 390.19C600.456 390.19 624.666 353.6 643.726 347.81",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M687.206 391.06C687.206 391.06 662.486 353.72 643.036 347.8",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M683.016 315.46C683.016 315.46 660.866 342.55 643.426 346.84",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M601.346 315.46C601.346 315.46 624.696 342.55 643.066 346.84",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M642.616 350.59C644.151 350.59 645.396 349.345 645.396 347.81C645.396 346.275 644.151 345.03 642.616 345.03C641.081 345.03 639.836 346.275 639.836 347.81C639.836 349.345 641.081 350.59 642.616 350.59Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M643.246 290.36C624.796 293.79 601.346 315.46 601.346 315.46",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M682.846 315.46C682.846 315.46 660.886 293.79 643.596 290.36",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M686.656 253.35C686.656 253.35 662.736 285.3 643.906 290.36",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M599.466 253.35C599.466 253.35 623.616 285.3 642.616 290.36",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M642.616 293.14C644.151 293.14 645.396 291.895 645.396 290.36C645.396 288.825 644.151 287.58 642.616 287.58C641.081 287.58 639.836 288.825 639.836 290.36C639.836 291.895 641.081 293.14 642.616 293.14Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M691.896 255.6V389.84C691.896 391.86 690.257 393.51 688.227 393.51H679.056C674.126 393.51 670.137 389.51 670.137 384.59V259.98C670.137 255.55 673.737 251.95 678.167 251.95H688.227C690.247 251.95 691.896 253.59 691.896 255.62V255.6Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M955.487 182.8H951.507V280.46H955.487V182.8Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M899.346 296.85H805.066C804.68 296.85 804.366 297.163 804.366 297.55V298.92C804.366 299.307 804.68 299.62 805.066 299.62H899.346C899.733 299.62 900.046 299.307 900.046 298.92V297.55C900.046 297.163 899.733 296.85 899.346 296.85Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M927.697 280.32H709.057V395.52H927.697V280.32Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  }))), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M922.237 284.48H714.297V392.59H922.237V284.48Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M756.546 334.54C756.546 347.83 756.856 359.74 753.436 358.61C744.766 355.75 743.356 347.8 743.356 334.5C743.356 321.2 745.146 314.46 753.436 310.46C756.846 308.82 756.546 321.24 756.546 334.53V334.54Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M758.007 359.55C758.007 359.55 777.297 366.83 790.657 368.88C809.137 371.71 786.897 386.95 771.777 386.68C756.097 386.4 748.627 386.01 749.057 373.25C749.437 362.03 758.007 359.55 758.007 359.55Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M774.257 369.96C774.257 369.96 764.027 369.9 759.477 362.34C758.737 361.12 756.927 361 755.587 362.11C754.437 363.07 753.537 364.44 753.997 366.26C756.417 375.83 770.237 373.17 773.467 372.57C773.467 372.57 778.547 370.9 774.257 369.96Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M775.976 340.33C780.505 340.33 784.176 336.659 784.176 332.13C784.176 327.601 780.505 323.93 775.976 323.93C771.448 323.93 767.776 327.601 767.776 332.13C767.776 336.659 771.448 340.33 775.976 340.33Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M785.497 378.65C787.336 378.65 788.827 377.159 788.827 375.32C788.827 373.481 787.336 371.99 785.497 371.99C783.658 371.99 782.167 373.481 782.167 375.32C782.167 377.159 783.658 378.65 785.497 378.65Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M899.427 305.2H819.597C819.254 305.2 818.977 305.478 818.977 305.82V307.13C818.977 307.472 819.254 307.75 819.597 307.75H899.427C899.769 307.75 900.047 307.472 900.047 307.13V305.82C900.047 305.478 899.769 305.2 899.427 305.2Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M899.437 313.56H827.287C826.95 313.56 826.677 313.833 826.677 314.17V315.72C826.677 316.057 826.95 316.33 827.287 316.33H899.437C899.774 316.33 900.047 316.057 900.047 315.72V314.17C900.047 313.833 899.774 313.56 899.437 313.56Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M899.307 321.92H793.737C793.328 321.92 792.997 322.251 792.997 322.66V323.95C792.997 324.359 793.328 324.69 793.737 324.69H899.307C899.716 324.69 900.047 324.359 900.047 323.95V322.66C900.047 322.251 899.716 321.92 899.307 321.92Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M899.307 330.27H793.737C793.328 330.27 792.997 330.601 792.997 331.01V332.3C792.997 332.709 793.328 333.04 793.737 333.04H899.307C899.716 333.04 900.047 332.709 900.047 332.3V331.01C900.047 330.601 899.716 330.27 899.307 330.27Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M899.307 338.63H793.737C793.328 338.63 792.997 338.961 792.997 339.37V340.66C792.997 341.069 793.328 341.4 793.737 341.4H899.307C899.716 341.4 900.047 341.069 900.047 340.66V339.37C900.047 338.961 899.716 338.63 899.307 338.63Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M899.307 346.99H793.737C793.328 346.99 792.997 347.321 792.997 347.73V349.02C792.997 349.429 793.328 349.76 793.737 349.76H899.307C899.716 349.76 900.047 349.429 900.047 349.02V347.73C900.047 347.321 899.716 346.99 899.307 346.99Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M899.307 355.34H793.737C793.328 355.34 792.997 355.671 792.997 356.08V357.37C792.997 357.779 793.328 358.11 793.737 358.11H899.307C899.716 358.11 900.047 357.779 900.047 357.37V356.08C900.047 355.671 899.716 355.34 899.307 355.34Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M899.347 363.7H808.667C808.285 363.7 807.977 364.009 807.977 364.39V365.78C807.977 366.161 808.285 366.47 808.667 366.47H899.347C899.728 366.47 900.037 366.161 900.037 365.78V364.39C900.037 364.009 899.728 363.7 899.347 363.7Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M899.326 372.06H803.816C803.424 372.06 803.106 372.378 803.106 372.77V374.12C803.106 374.512 803.424 374.83 803.816 374.83H899.326C899.719 374.83 900.036 374.512 900.036 374.12V372.77C900.036 372.378 899.719 372.06 899.326 372.06Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M899.997 380.41H799.597C799.199 380.41 798.877 380.732 798.877 381.13V382.46C798.877 382.858 799.199 383.18 799.597 383.18H899.997C900.395 383.18 900.717 382.858 900.717 382.46V381.13C900.717 380.732 900.395 380.41 899.997 380.41Z",
    stroke: "#B1AFB1",
    strokeWidth: 0.12,
    strokeMiterlimit: 10
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M793.616 294.13C795.426 290.67 797.876 289.35 801.266 289.35H895.546C905.326 289.35 913.256 300.02 913.256 313.18V377.16C913.256 384.6 908.776 390.64 903.236 390.64H801.256C798.186 390.64 794.856 388.3 792.986 384.83",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M804.577 361.89C804.577 361.89 800.737 392.58 767.227 392.58H714.997V284.47H772.217C772.217 284.47 802.187 291.45 804.587 313.9L806.877 335.34L804.587 361.88L804.577 361.89Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M771.057 362.02C773.957 362.74 780.537 365.14 788.707 365.6C810.317 366.81 829.677 350.58 829.677 332.12C829.677 313.66 812.137 298.71 790.507 298.71C785.047 298.71 779.947 300.08 775.117 301.39C765.197 304.07 756.687 312.35 756.687 312.35C753.537 316.02 751.337 324.53 751.337 334.44C751.337 340.79 752.247 346.57 753.717 350.86C754.647 353.55 756.457 355.7 758.787 356.89C762.327 358.69 768.137 361.3 771.057 362.02Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M790.587 356.51C806.642 356.51 819.657 345.595 819.657 332.13C819.657 318.665 806.642 307.75 790.587 307.75C774.532 307.75 761.517 318.665 761.517 332.13C761.517 345.595 774.532 356.51 790.587 356.51Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M945.757 100.59H943.657V99.86H843.097V100.59V180.21H943.657H945.757V394.98H1122.56V100.59H945.757Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M700.937 251.93H506.937V407.75H700.937V251.93Z",
    fill: "#D3D3D3"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M1028.83 101.96V99.46H844.807V280.25H936.817V282.74V396.11H1120.84V284.32V240.3V101.96H1028.83Z",
    fill: "#D3D3D3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.737 99.67H566.797V190.67H841.737V99.67Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M599.837 109.82H695.187C709.167 109.82 720.507 121.17 720.507 135.14V169.54C720.507 175.56 715.617 180.45 709.597 180.45H599.827C593.807 180.45 588.917 175.56 588.917 169.54V120.73C588.917 114.71 593.807 109.82 599.827 109.82H599.837Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M835.096 102.56H574.626C572.754 102.56 571.236 104.078 571.236 105.95V183.16C571.236 185.032 572.754 186.55 574.626 186.55H835.096C836.969 186.55 838.486 185.032 838.486 183.16V105.95C838.486 104.078 836.969 102.56 835.096 102.56Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M654.716 151.31C658.107 151.31 660.856 148.561 660.856 145.17C660.856 141.779 658.107 139.03 654.716 139.03C651.325 139.03 648.576 141.779 648.576 145.17C648.576 148.561 651.325 151.31 654.716 151.31Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M654.716 150.4C657.605 150.4 659.946 148.058 659.946 145.17C659.946 142.282 657.605 139.94 654.716 139.94C651.828 139.94 649.486 142.282 649.486 145.17C649.486 148.058 651.828 150.4 654.716 150.4Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M718.303 114.003L716.033 111.733C715.424 111.124 714.436 111.124 713.827 111.733L683.577 141.983C682.967 142.593 682.967 143.58 683.577 144.19L685.846 146.459C686.456 147.069 687.443 147.069 688.053 146.459L718.303 116.209C718.912 115.6 718.912 114.612 718.303 114.003Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M841.737 99.6699H566.797V190.67H841.737V99.6699Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M927.697 280.32H709.057V395.52H927.697V280.32Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M700.937 251.93H506.937V407.75H700.937V251.93Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M1028.83 101.96V99.46H844.807V280.25H936.817V282.74V396.11H1120.84V284.32V240.3V101.96H1028.83Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M725.387 104.14V190.34H833.657V104.14H725.387Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M725.387 104.14V190.34H833.657V104.14H725.387Z",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M710.037 111.07C710.037 111.07 708.477 112.26 700.107 114.73C696.247 118.55 701.827 120.04 701.827 120.04C701.827 120.04 708.297 118.98 713.777 119.73",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M710.037 111.07C710.037 111.07 708.477 112.26 700.107 114.73C696.247 118.55 701.827 120.04 701.827 120.04C701.827 120.04 708.297 118.98 713.777 119.73",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M713.767 119.73C716.788 119.73 719.237 117.491 719.237 114.73C719.237 111.969 716.788 109.73 713.767 109.73C710.746 109.73 708.297 111.969 708.297 114.73C708.297 117.491 710.746 119.73 713.767 119.73Z",
    fill: "white",
    stroke: "#B1AFB1",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.43,
    d: "M934.636 132.36H861.736V177.96H934.636V132.36Z",
    fill: "#D3D3D3"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M934.637 173.97V177.97H930.637",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M923.427 177.97H869.347",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M865.736 177.97H861.736V173.97",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M861.736 166.45V140.12",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M861.736 136.36V132.36H865.736",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M872.956 132.36H927.026",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M930.637 132.36H934.637V136.36",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M934.637 143.88V170.21",
    stroke: "#26231E",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M674.007 394.09V394.59H673.507",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M672.517 394.59H507.937",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M507.437 394.59H506.937V394.09",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M506.937 393.07V341.02",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M506.937 340.51V340.01H507.437",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M508.437 340.01H673.007",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M673.507 340.01H674.007V340.51",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M674.007 341.52V393.58",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M674.007 340.01H506.937V394.58H674.007V340.01Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M948.037 81.3H492.997V135.87H948.037V81.3Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  }))), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M948.037 135.38V135.88H947.537",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M946.537 135.88H493.997",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M493.497 135.88H492.997V135.38",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M492.997 134.37V82.3101",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M492.997 81.8V81.3H493.497",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M494.497 81.3H947.037",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M947.537 81.3H948.037V81.8",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M948.037 82.8101V134.87",
    stroke: "#006CFA",
    strokeOpacity: 0.76,
    strokeMiterlimit: 10
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M377.787 99.05H311.577C309.583 99.05 307.967 100.666 307.967 102.66V204.3C307.967 206.294 309.583 207.91 311.577 207.91H377.787C379.781 207.91 381.397 206.294 381.397 204.3V102.66C381.397 100.666 379.781 99.05 377.787 99.05Z",
    fill: "#338CFF",
    fillOpacity: 0.13
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M377.787 99.05H311.577C309.583 99.05 307.967 100.666 307.967 102.66V204.3C307.967 206.294 309.583 207.91 311.577 207.91H377.787C379.781 207.91 381.397 206.294 381.397 204.3V102.66C381.397 100.666 379.781 99.05 377.787 99.05Z",
    stroke: "#26231E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M377.637 108.13H311.717C310.469 108.13 309.457 109.142 309.457 110.39V150.14C309.457 151.388 310.469 152.4 311.717 152.4H377.637C378.885 152.4 379.897 151.388 379.897 150.14V110.39C379.897 109.142 378.885 108.13 377.637 108.13Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M377.637 154.85H311.717C310.469 154.85 309.457 155.862 309.457 157.11V196.86C309.457 198.108 310.469 199.12 311.717 199.12H377.637C378.885 199.12 379.897 198.108 379.897 196.86V157.11C379.897 155.862 378.885 154.85 377.637 154.85Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M380.106 122.4H372.146V138.74H380.106V122.4Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M380.106 168.81H372.146V185.15H380.106V168.81Z",
    fill: "white",
    stroke: "#25221E",
    strokeWidth: 0.28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarBayrun3);
export default __webpack_public_path__ + "static/media/car_bayrun3.917c3c3c34f118f6c54dda341fe9aa7e.svg";
export { ForwardRef as ReactComponent };